import React from 'react';
import {
  emptyPerson,
  getDialCodeForBridgeCountry,
} from '../../utils/bridgeStaff';
import PersonFields from './PersonFields';

const ActionPlaceholder = () => (
  <span className="btn-staff btn-staff-placeholder" aria-hidden="true" />
);

/** Bridge admins for super admin company flow. */
export default function UnlimitedAdminList({ title, list, onChange, bridgeCountry }) {
  const defaultDial = getDialCodeForBridgeCountry(bridgeCountry);

  const update = (idx, person) => {
    const next = [...list];
    next[idx] = person;
    onChange(next);
  };

  const add = () => {
    onChange([...list, emptyPerson(defaultDial)]);
  };

  const remove = (idx) => {
    if (idx === 0) return;
    onChange(list.filter((_, i) => i !== idx));
  };

  return (
    <div className="staff-section staff-section--unlimited">
      <h3 className="staff-section-title">{title}</h3>
      <div className="staff-section-scroll">
        {list.map((person, idx) => (
          <div key={idx} className="staff-row">
            <div className="staff-fields with-code">
              <PersonFields
                person={person}
                onChange={(p) => update(idx, p)}
                bridgeCountry={bridgeCountry}
              />
            </div>
            <div className="staff-row-actions">
              <button type="button" className="btn-staff btn-staff-add" onClick={add} title="Add row">
                +
              </button>
              {idx > 0 ? (
                <button
                  type="button"
                  className="btn-staff btn-staff-remove"
                  onClick={() => remove(idx)}
                  title="Remove row"
                >
                  −
                </button>
              ) : (
                <ActionPlaceholder />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
